module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Deadline-Gallipoli.a2d8b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Deadline-Gallipoli.jpg
// module id = dO9R
// module chunks = 0